import { defineMessages } from 'react-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reloadLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rateLimitedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rateLimitedDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rovoInactiveTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rovoInactiveDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'ai-mate.chat-error.generic-title',
		defaultMessage: 'Something went wrong',
		description:
			'Title text displayed at the top of a generic error message within the AI conversation interface when an unexpected error occurs. Shown as the heading of an error notification or error state component. The purpose is to immediately communicate to the user that an error occurred, even though the specific cause is unknown.',
	},
	reloadLink: {
		id: 'ai-mate.chat-error.reload-link',
		defaultMessage: 'Reload to try again',
		description:
			'Link text displayed in the body of a generic error notification within the AI conversation interface, providing guidance on how to fix the issue.',
	},
	rateLimitedTitle: {
		id: 'ai-mate.chat-error.rate-limited-title',
		defaultMessage: 'Too many requests',
		description:
			'Title text displayed at the top of a rate limit error message within the AI conversation interface when a user has exceeded the maximum number of allowed requests. Shown as the heading of an error notification. The purpose is to immediately communicate to the user that they have hit a rate limit.',
	},
	rateLimitedDescription: {
		id: 'ai-mate.chat-error.rate-limited-description',
		defaultMessage: 'You have reached the maximum number of requests. Please try again later.',
		description:
			'Error message text displayed in the body of a rate limit error notification within the AI conversation interface, explaining why the request was blocked. Shown as the description text below the error title. The purpose is to inform the user that they have exceeded the rate limit and need to wait before making additional requests.',
	},
	rovoInactiveTitle: {
		id: 'ai-mate.chat-error.rovo-inactive-title',
		defaultMessage: 'Rovo is inactive',
		description:
			"Title text displayed at the top of an error message within the AI conversation interface when Rovo (the AI assistant) is not enabled or active on the user's site. Shown as the heading of an error notification. The purpose is to immediately communicate to the user that Rovo is not available because it has not been set up or enabled.",
	},
	rovoInactiveDescription: {
		id: 'ai-mate.chat-error.rovo-inactive-description',
		defaultMessage: "Looks like Rovo isn't enabled on your site. <link>Setting up Rovo</link>",
		description:
			'Error message text displayed in the body of an error notification within the AI conversation interface when Rovo is inactive, explaining the issue and providing a solution. Shown as the description text below the error title. The <link> tags will be rendered as a clickable link with the text "Setting up Rovo". When clicked, it opens documentation or setup instructions for enabling Rovo. The purpose is to inform the user why Rovo is unavailable and guide them to set it up.',
	},
});
